import {RecordKind, Gender} from '../api/api';
import locationIconUrl from '../assets/location.svg?url';
import businessIconUrl from '../assets/business.svg'

interface MarkerData {
    RecordKind: RecordKind,
    Gender?: Gender | '',
    AgeRange?: string,
    SAVOLO?: string | null
}

export type ColorCodingMode = 'gender' | 'age_range' | 'savolo';

export function getMarkerProps(marker: MarkerData, colorCoding: ColorCodingMode){
    const props : maplibregl.MarkerOptions = {}
    
    if (marker.RecordKind == 'business'){
        const el =  document.createElement('img')
        el.src = businessIconUrl;                
        props.element = el;
    } else if (marker.RecordKind == 'location' ) {
        const el =  document.createElement('img')
        el.src = locationIconUrl;                
        props.element = el;
    } else {
        if (colorCoding === 'gender') {
            const COLOR_MAP: Record<Gender | '', string> = {
                'male':  '#0000FF',
                'female': '#FF1493',
                'other':  '#a02dcaff',
                '': '#808080'
            }
            props.color = COLOR_MAP[marker.Gender || ''];
        } else if (colorCoding === 'age_range'){
             const COLOR_MAP: Record<string, string> = {
                 '0-25': '#FF0000',
                 '26-49': '#FFA500',
                 '50+':'#FFFF00'
            }
            props.color = COLOR_MAP[marker.AgeRange || ''];
        } else if (colorCoding == 'savolo'){
            const COLOR_MAP : Record<string, string> = {
                'Yes': '#FF0000',
                'No': '#008000',
                'Unknown': '#FFFF00'
            }
            props.color = COLOR_MAP[marker.SAVOLO || ''];
        }
        props.color ||= '#808080';
    }

    return props;
}